(function Processor($, Adzuki)
{
	'use strict';

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Reports/valueTrackerProcessor', function onload() {
			Adzuki.Ajax.get('/Reports/valueTrackerCheckBookings')
			.then(function success(response) {
				if (response.return_value === 'complete') {
					window.location.href = Adzuki.base_uri + '/Reports/valueTrackerResults';
				}

				if (response.return_value === 'exception') {
					window.location.href = Adzuki.base_uri + '/Reports/valueTracker';
				}
			});

			$('.econnect-loader').dblclick(function swapLoader() {
				$(this).attr('src', Adzuki.base_uri + '/adzuki/images/econnect-loader-homer.gif');
			});
		}, false);
	});
}(jQuery, window.Adzuki || {}));
